module.exports = __webpack_public_path__ + "dbee1c4201517c33a8c7269601afc5c7.woff2";